import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Box, Divider, Grid, Typography } from "@material-ui/core";
import Backdrop from "@material-ui/core/Backdrop";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { useAppDispatch, useAppSelector } from "src/app-redux/hooks";
import { addUserAction } from "src/app-redux/management/actions/managementActions";
import { selectRoles, selectStatus } from "src/app-redux/management/managementSlice";
import { IInactiveUserUser } from "src/common/typings/user";
import UseWindowDimensions from "src/common/utils/getWindowDimensions";
import CommonButton from "src/components/CommonButton/CommonButton";
import TabHeader from "src/components/TabHeader/TabHeader";
import { AddInactiveUser, IForm } from "./components/AddInActiveUser";
import { SettingsRoute } from "src/modules/settings/setting.routes";
import CommonLoader from "src/components/Loader/CommonLoader";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
    },
    pageHeading: {
      fontSize: theme.typography.pxToRem(20),
      fontWeight: theme.typography.fontWeightRegular,
      color: "#000",
      lineHeight: "28px",
    },

    breadcrumbs: {
      fontSize: theme.typography.pxToRem(12),
    },

    backdrop: {
      zIndex: theme.zIndex.modal + 1,
      color: "#fff",
    },
    cardMainParent: {
      float: "left",
      width: "100%",
    },
    cardMain: {
      marginBottom: "30px",
      paddingTop: "10px",
      width: "calc(100%)",
    },
  })
);

interface Props {}

export function AddNewUser({}: Props): React.ReactElement {
  const classes = useStyles();
  const history = useHistory();
  const allRoles = useAppSelector(selectRoles);
  const [InactiveUserList, setInactiveUserList] = React.useState<any[]>([]);
  const [InactiveList, setInactiveList] = React.useState<any[]>([]);
  const [selUser, setSelUser] = React.useState<string>("");
  const [selUserValue, setSelUserValue] = React.useState<IInactiveUserUser>();
  const dispatch = useAppDispatch();
  const addStatus = useAppSelector(selectStatus);
  const [pageHeading, setPageHeading] = React.useState<any>("Add New User");
  const [moduleName, setmoduleName] = React.useState<any>(SettingsRoute.title);

  useEffect(() => {
    if (selUser && InactiveUserList.length) {
      const result = InactiveUserList.filter((ven: IInactiveUserUser) => ven.id === selUser);
      if (result) setSelUserValue(result[0]);
    }
  }, [selUser]);

  const handleSubmit = async (formData: IForm) => {
    const clone = JSON.parse(JSON.stringify(formData));
    const res = await dispatch(addUserAction(clone));
    if (res.payload) history.push(SettingsRoute.path); // Return to homescreen
  };
  const [submitCounter, setSubmitCounter] = useState(0);
  const { height } = UseWindowDimensions();
  let wHeight = 0;
  const minHeight = 132;
  wHeight = height - minHeight;

  const listener = (e: any) => {
    if (
      (e.key === "s" || e.key === "S") &&
      (navigator.platform.match("Mac") ? e.metaKey : e.ctrlKey)
    ) {
      e.preventDefault();
      if (addStatus !== "loading") setSubmitCounter((prev) => prev + 1);
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, [addStatus]);

  return (
    <>
      <TabHeader module={moduleName} heading={pageHeading} link={SettingsRoute.path} />
      <Backdrop className={classes.backdrop} open={addStatus === "loading"}>
        <CommonLoader />
      </Backdrop>
      <Box m={2} />
      <Grid item xs={12} md={12} className={classes.cardMainParent} style={{ height: wHeight }}>
        <Box pl={2} pr={2}>
          <Grid container direction="row">
            <Grid item xs={12} md={10}>
              <Typography color="textPrimary" className={classes.pageHeading}>
                {pageHeading}
              </Typography>
            </Grid>
            <Grid item xs={12} md={2}>
              <Box textAlign="right">
                <Box component="span">
                  <CommonButton
                    cssClass="customSubmitBtn"
                    isGreen
                    onClick={() => setSubmitCounter((prev) => prev + 1)}
                  >
                    Save
                  </CommonButton>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
        <Box m={1}>
          <Divider />
        </Box>
        <Grid container alignItems="center">
          <AddInactiveUser
            allRoles={allRoles}
            submitCounter={submitCounter}
            handleSubmit={handleSubmit}
            userCompStatus={true}
            initialValues={selUserValue}
            InactiveList={InactiveList}
            setusersSelected={(val: string) => {
              setSelUser(val); // it get returns a value and update the state and useEffect is Called
            }}
            selUser={selUser}
          />
        </Grid>
      </Grid>
    </>
  );
}
